import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

export default function LegacyVideoRedirect({ language }: { language?: string }) {
  const { narratorId } = useParams();
  const { search, hash, state } = useLocation();
  const prefix = language ? `/${language}` : '';
  const pathname = `${prefix}/videos${narratorId ? `/${encodeURIComponent(narratorId)}` : ''}`;

  return <Navigate to={{ pathname, search, hash }} state={state} replace />;
}
